import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable max-len */
import cc from 'classcat';
import PropTypes from 'prop-types';
import Icon from '../icons/EverGreen';
import ToolTip from '../ToolTip';
import css from './EverGreen.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EverGreen = function EverGreen(_ref) {
  var _ref2;

  var center = _ref.center,
      info = _ref.info,
      large = _ref.large,
      small = _ref.small;
  var copy = 'Our line of sustainable fabrics developed through a lens of longevity. Made from over 50% preferred materials in an effort to reduce our environmental impact.';
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, (_ref2 = {}, _defineProperty(_ref2, css.center, center), _defineProperty(_ref2, css.small, small), _defineProperty(_ref2, css.large, large), _ref2)]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.iconWrapper,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.icon,
        children: /*#__PURE__*/_jsx(Icon, {})
      }), info && /*#__PURE__*/_jsx("div", {
        className: css.tooltip,
        children: /*#__PURE__*/_jsx(ToolTip, {
          id: "evergreen-tooltip",
          text: copy
        })
      })]
    }), !small && /*#__PURE__*/_jsx("p", {
      className: css.description,
      children: copy
    })]
  });
};

EverGreen.defaultProps = {
  center: false,
  info: false,
  large: false,
  small: false
};
EverGreen.propTypes = {
  center: PropTypes.bool,
  info: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool
};
export default EverGreen;